var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"e-dialog__body"},[_c('div',{staticClass:"e-dialog__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.body)}}),(_vm.addendum)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.addendum)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }